module.exports = __webpack_public_path__ + "static/sergiler1-eadff72c88a669ffc66b3ec3299b8480.jpg";